import { useLocation } from "react-router-dom";

const useIsCreate = () => {
  const location = useLocation();
  const isCreate = location.pathname.includes("create");
  return isCreate;
};

export default useIsCreate;
